export interface ITypeOfIdentification {
  idTypeOfDocument: number;
  TypeOfDocument: string;
  allowFreeText: boolean;
}

export const staticTypeOfIdentificationArray: ITypeOfIdentification[] = [
  {
    idTypeOfDocument: 1,
    TypeOfDocument: 'Deutscher Personalausweis',
    allowFreeText: false,
  },
  {
    idTypeOfDocument: 2,
    TypeOfDocument: 'Deutscher Reisepass',
    allowFreeText: false,
  },
  {
    idTypeOfDocument: 3,
    TypeOfDocument: 'Anderer europäischer Personalausweis/Reisepass',
    allowFreeText: false,
  },
  {
    idTypeOfDocument: 4,
    TypeOfDocument: 'Sonstiges Ausweisdokument',
    allowFreeText: true,
  },
];
